import React, {useState} from "react";
import {InputAdornment, TextField} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import {Autocomplete} from "@material-ui/lab";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    rootAutocompleteBase: {
        borderRadius: '18px',

        '@media (max-width: 1180px)': {
            width: '100%'
        }
    },
    rootAutocomplete: {
        border: '2px solid #F0F0F0',
        borderRadius: '18px',
        height: '33px',
        transition: 'all .4s cubic-bezier(1,0,1,0)',
        alignItems: 'center',
        padding: '0px 39px 0px 0px !important',
        flexWrap: 'nowrap',
    },
    rootAutocompleteNotExpanded: {
        border: '2px solid #F0F0F0',
        borderRadius: '18px',
        height: '33px',
        transition: 'all .4s cubic-bezier(1,0,1,0)',
        padding: '0px 6px !important',
        alignItems: 'center',
    },
    notchedOutline: {
        border: "none",
    },
    endAdornment: {
        background: theme.palette.grey.accordion,
        borderRadius: '0px 18px 18px 0px',
        position: 'absolute',
        right: 0,
        top: 0,
        zIndex: 1,
        height: '100%',
        cursor: 'pointer',
        width: '100px',
        display: "flex",
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "center",
        transition: 'all .4s',

        '@media (max-width: 1180px)': {
            display: 'none',
        }
    },
    endAdornmentText: {
        fontSize: '14px',
        fontWeight: 700,
        paddingLeft: theme.spacing(2),
    },
    customTextField: {
    }
}));

const CabinetAutocomplete = ({useSelectedTag, useCatalogForView, handleValue, usePrevState}) => {
    const classes = useStyles();
    const [filteredValue, handleChangeFilterValue] = handleValue;
    const [expand, setExpand] = useState(true);

    const handleExpand = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setExpand(prev => !prev);
    }

    const handleChangeValue = (e) => {
        handleChangeFilterValue(e);
    }

    return (<Autocomplete
        multiple
        freeSolo
        open={false}
        options={[]}
        inputValue={filteredValue}
        className={classes.rootAutocompleteBase}
        renderInput={(params) => {
            return (
                <TextField
                    {...params}
                    style={expand
                        ? {transition: 'all .5s ease-out', background: 'white', borderRadius: '18px',}
                        : {width: '38px', transition: 'all .5s ease-out', background: 'white', borderRadius: '18px',}
                    }
                    placeholder={"Введіть назву дослідження..."}
                    onClick={(e) => !expand && handleExpand(e)}
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: (<InputAdornment position="start"
                                                         style={expand
                                                             ? {paddingLeft: '8px', transition: 'all .4s cubic-bezier(1,0,1,0)'}
                                                             : {cursor: 'pointer', opacity: 1, color: 'black', transition: 'all .4s cubic-bezier(1,0,1,0)'}}
                                                         onClick={(e) => expand && handleExpand(e)}>
                            <SearchIcon fontSize="small" color="inherit" style={{color: '#6e6e6f'}}/>
                        </InputAdornment>),
                        endAdornment: (
                                <div className={classes.endAdornment}>
                                    <p className={classes.endAdornmentText}
                                       style={expand ? {transition: 'all .5s'} : {display: 'none', transition: 'all .5s'}}>
                                        Пошук
                                    </p>
                                </div>
                        ),
                        classes: {
                            root: expand ? classes.rootAutocomplete : classes.rootAutocompleteNotExpanded,
                            notchedOutline: classes.notchedOutline
                        }
                    }}
                    variant="outlined"
                    onChange={handleChangeValue}
                />)}}
    />);
};

export default CabinetAutocomplete;
